import { createReducer } from '@reduxjs/toolkit';
import type { IUser } from 'types/IUser';
import { fetchUsers, fetchUsersByLottery, fetchUser, createUser, updateUser, deleteUser } from 'store/actions/userActions';

export interface UserState {
  users: IUser[];
  selectedUser: IUser | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  users: [],
  selectedUser: null,
  loading: false,
  error: null,
};

const userReducer = createReducer<UserState>(initialState, (builder) => {
  builder
    .addCase(fetchUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
    })
    .addCase(fetchUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Fehler beim Laden der Benutzer';
    })
    .addCase(fetchUsersByLottery.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
    })
    .addCase(fetchUser.fulfilled, (state, action) => {
      state.selectedUser = action.payload;
    })
    .addCase(createUser.fulfilled, (state, action) => {
      state.users.push(action.payload);
    })
    .addCase(updateUser.fulfilled, (state, action) => {
      const index = state.users.findIndex((u) => u.id === action.payload.id);
      if (index >= 0) state.users[index] = action.payload;
    })
    .addCase(deleteUser.fulfilled, (state, action) => {
      state.users = state.users.filter((u) => Number(u.id) !== action.meta.arg);
    });
});

export default userReducer;
